<div [ngClass]="{'dettaglio-date-container-acl': acl == 'eell'}" class="dettaglio-date-container">

  <h1 class="colorSearch" mat-dialog-title>UPLOAD FILE {{this.nomeEvento}} </h1>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Numero Protocollo Ente Attuatore</mat-label>
    <input matInput required [(ngModel)]="numProtoEnteAt" name="numProtoEnteAt" #numProtoInput="ngModel" (ngModelChange)="validateNumProto(numProtoEnteAt)" (blur)="numProtoInput.control.markAsTouched()">
    <mat-error *ngIf="numProtoInput.errors?.nonNumeric">
      Inserire solo valori numerici
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Data Protocollo Ente Attuatore</mat-label>
    <input matInput [matDatepicker]="picker" required [(ngModel)]="dataProtoEnteAt" name="dataProtoEnteAt">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <div class="file-upload-container">
    <div class="upload-area" (click)="fileInput.click()">
      <input #fileInput type="file" (change)="onFileSelected($event)" style="display: none;">
      <mat-icon>cloud_upload</mat-icon>
      <p>Fare clic per selezionare un file o trascinarlo</p>
    </div>

    <div *ngIf="fileName" class="file-info">
      <div class="file-details">
        <mat-icon>insert_drive_file</mat-icon>
        <div>
          <p><strong>{{ fileName }}</strong> • {{ fileSize }} • {{ fileType }}</p>
        </div>
      </div>

      <div *ngIf="isUploading" class="progress-bar">
        <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
        <span>{{ uploadProgress }}%</span>
      </div>

      <mat-dialog-actions align="end">
        <button mat-stroked-button color='accent' class='persBtn'
          [disabled]="uploadCompletedWithoutErrors || isUploading || !numProtoEnteAt || !dataProtoEnteAt || isNumProtoInvalid" mat-raised-button (click)="uploadFile()">
          <span *ngIf="!isUploading">Upload</span>
          <span *ngIf="isUploading">Uploading...</span>
        </button>
      </mat-dialog-actions>
    </div>
  </div>

  <mat-dialog-actions align="end">
    <button mat-stroked-button color='accent' class='persBtn' mat-dialog-close>
      <p class='cont'>CHIUDI</p>
    </button>
  </mat-dialog-actions>

</div>
